import {
  createUserDirectoryCache,
  UserDirectoryCache,
} from './user-directory-cache';

let _instance: UserDirectoryCache | undefined;
export function userDirectoryInstance() {
  if (!_instance) {
    _instance = createUserDirectoryCache();
  }
  return _instance;
}
